<template>
  <div class="mainUser">
    <!-- 快递查价条件  start-->
    <div
      class="chkListTop topHeader"
      :style="
        showNum.length
          ? 'height: 64px;background:#F9F9F9;border-radius: 10px 10px 0 0;'
          : ''
      "
    >
      <p style="display: inline" id="cityWidth">
        <b>{{ startCityEn }}</b>
        <i class="fa fa-arrowEdit"></i>
        <b>{{ desCountryEn }}</b>
      </p>
      <ul>
        <li v-if="!showNum.length">Commodity:{{ goodsInfos }}</li>
      </ul>
    </div>
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item name="1" class="collapseContent">
        <template slot="title">
          <a
            class="blueBtnMax marL30 serchbtn"
            :style="{ left: cityWidth + 'px' }"
            @click="clkEditCond"
            v-if="!(this.$route.query.zt == 1)"
            >Edit Search</a
          >
        </template>
        <div class="mainBox" v-show="isShowCond">
          <div
            class="listContent"
            style="margin: 0 0 15px; position: relative; border-radius: 0 0 10px 10px"
          >
            <div class="chkOneCon">
              <div class="chkContent">
                <ul class="checkInput" style="display: flex">
                  <li>
                    <span class="checkInTitle from">
                      <b>From：</b>
                    </span>

                    <span style="margin-right: 0">
                      <expStartCity
                        :class="{ borRed: isReq == 1 ? true : false }"
                        setWidth="212px"
                        height="32px"
                        setPlaceholder="City"
                        @byCityValue="byCityValue"
                        ref="startInput"
                      ></expStartCity>
                      <p v-show="isReq == 1 ? true : false" class="rigMsgRed">Required</p>
                    </span>
                  </li>
                  <li style="position: relative; right: 30px">
                    <span class="checkInTitle to">
                      <b>To：</b>
                    </span>
                    <span>
                      <expDesCountry
                        :class="{ borRed: isReq == 3 ? true : false }"
                        setWidth="212px"
                        height="32px"
                        setPlaceholder="Country"
                        @byCountryValue="byCountryValue"
                        ref="endInput"
                      ></expDesCountry>
                      <p v-show="isReq == 3 ? true : false" class="rigMsgRed">Required</p>
                    </span>
                  </li>
                </ul>
                <div class="cl"></div>
              </div>
            </div>
            <div class="chkTwoCon">
              <div class="chkContent">
                <ul class="chkTwoUl">
                  <li v-show="PacketType == 1" class="cl">
                    <b class="title" style="width: 118px">Shipment：</b>
                    <label class="text" style="padding-left: 7px">
                      <span class="hint marR5 shipmentSpan" style="padding-bottom: 10px">
                        <el-radio v-model="QueryType" :label="2" @change="clkQuType"
                          >Calculate by boxes/pallets</el-radio
                        >
                        <div class="floTipBox" style="right: 0px; top: 25px">
                          <i></i>
                          <p>
                            Input cargo weight, length/width/height to ensure the accuracy
                            of total freight.You can click "add another unit" to add
                            different sizes of packaging info., the system will
                            automatically calculate the total load.
                          </p>
                        </div>
                      </span>
                      <!-- <el-radio v-model="QueryType" :label="2" @change="clkQuType">Calculate by boxes/pallets</el-radio> -->
                      <el-radio v-model="QueryType" :label="1" @change="clkQuType"
                        >Calculate by total shipment</el-radio
                      >
                    </label>
                  </li>
                  <li v-show="PacketType == 1" class="cl">
                    <b class="title" style="width: 118px">Shipment units：</b>
                    <div class="text">
                      <div style="width: 880px">
                        <label
                          class="text2 radioWeight"
                          style="width: auto; padding-left: 7px"
                        >
                          <el-radio v-model="VolumeUnit" :label="0">KG/CBM</el-radio>
                          <el-radio v-model="VolumeUnit" :label="1">LB/CFT</el-radio>
                        </label>
                      </div>
                      <div class="cl centerInput">
                        <ul v-show="QueryType == 2">
                          <li v-for="(item, index) in radCargo" :key="index">
                            <label>
                              <div :class="{ borRed2: item.isCol1 }">
                                <input
                                  style="width: 128px"
                                  class="inputAll w1"
                                  type="text"
                                  placeholder="Same packages"
                                  v-model="item.Quanlity"
                                  @blur="radCargoBlur(item)"
                                  @keyup="item.Quanlity = checkNumInt(item.Quanlity)"
                                />
                                <p class="rigW" style="width: 113px; overflow: hidden">
                                  <el-select v-model="item.OrderUnit" class="unit_select">
                                    <el-option
                                      v-for="item in item.unitOptions"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    ></el-option>
                                  </el-select>
                                </p>
                              </div>

                              <p v-show="item.isCol1" class="rigMsgRed">Required</p>
                            </label>
                            <label>
                              <div :class="{ borRed2: item.isCol2 }">
                                <input
                                  class="inputRad radL"
                                  type="text"
                                  placeholder="Length"
                                  v-model="item.Long"
                                  @blur="radCargoBlur(item)"
                                  @keyup="item.Long = checkNum(item.Long)"
                                />
                                <input
                                  class="inputRad radC"
                                  type="text"
                                  placeholder="Width"
                                  v-model="item.Wide"
                                  @blur="radCargoBlur(item)"
                                  @keyup="item.Wide = checkNum(item.Wide)"
                                />

                                <input
                                  class="inputRad radR"
                                  type="text"
                                  placeholder="Height"
                                  v-model="item.Height"
                                  @blur="radCargoBlur(item)"
                                  @keyup="item.Height = checkNum(item.Height)"
                                />
                                <p class="rigW" v-if="VolumeUnit == 0">CM</p>
                                <p class="rigW" v-if="VolumeUnit == 1">IN</p>
                              </div>
                              <p
                                v-show="
                                  item.isCol2 &&
                                  (item.Wide == 0 || item.Long == 0 || item.Height == 0)
                                "
                                class="rigMsgRed"
                              >
                                must be greater than 0
                              </p>
                              <p
                                v-show="
                                  item.isCol2 &&
                                  item.Wide != 0 &&
                                  item.Long != 0 &&
                                  item.Height != 0
                                "
                                class="rigMsgRed"
                              >
                                Required
                              </p>
                            </label>
                            <label>
                              <div :class="{ borRed2: item.isCol3 }">
                                <input
                                  style="width: 205px"
                                  class="inputAll w1"
                                  type="text"
                                  placeholder="Weight of one box"
                                  v-model="item.Weight"
                                  @blur="radCargoBlur(item)"
                                  @keyup="item.Weight = checkNum(item.Weight)"
                                />
                                <p class="rigW" v-if="VolumeUnit == 0">KG</p>
                                <p class="rigW" v-if="VolumeUnit == 1">LB</p>
                              </div>
                              <p
                                v-show="item.isCol3 && item.Weight == 0"
                                class="rigMsgRed"
                              >
                                must be greater than 0
                              </p>
                              <p
                                v-show="item.isCol3 && item.Weight != 0"
                                class="rigMsgRed"
                              >
                                Required
                              </p>
                            </label>
                            <label style="margin: 13px 0px">
                              <i
                                class="fa fa-failure colRed l"
                                :class="{ isNone: radCargo.length == 1 }"
                                @click="delPackage(index)"
                              ></i>
                              <i
                                class="fa fa-add colBlue l marL5"
                                @click="addPackage(item)"
                              ></i>
                            </label>
                          </li>
                        </ul>
                        <ul v-show="QueryType == 1">
                          <li>
                            <label>
                              <div :class="{ borRed2: totalShipmentFlag.flagOne }">
                                <input
                                  style="width: 128px"
                                  class="inputAll w1"
                                  type="text"
                                  placeholder="Total cartons"
                                  v-model="inputUnits"
                                  @blur="totalShipmentGoBlur(inputUnits, 1)"
                                  @keyup="inputUnits = checkNumInt(inputUnits)"
                                />
                                <p class="rigW" style="width: 113px; overflow: hidden">
                                  <el-select v-model="unitValue" class="unit_select">
                                    <el-option
                                      v-for="item in unitOptions"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    >
                                    </el-option>
                                  </el-select>
                                </p>
                              </div>
                              <p v-show="totalShipmentFlag.flagOne" class="rigMsgRed">
                                Required
                              </p>
                            </label>
                            <label>
                              <div
                                :class="{
                                  borRed2: totalShipmentFlag.flagTwo,
                                }"
                              >
                                <input
                                  style="width: 220px"
                                  class="inputAll w1"
                                  type="text"
                                  placeholder="Total weight"
                                  v-model="inputWeight"
                                  @blur="totalShipmentGoBlur(inputWeight, 2)"
                                  @keyup="inputWeight = checkNum(inputWeight)"
                                />
                                <p class="rigW" v-if="VolumeUnit == 0">KG</p>
                                <p class="rigW" v-if="VolumeUnit == 1">LB</p>
                              </div>
                              <!-- <p
                                v-show="totalShipmentFlag.flagTwo && inputWeight == 0"
                                class="rigMsgRed"
                              >
                                must be greater than 0
                              </p> -->
                              <p
                                v-show="totalShipmentFlag.flagTwo && inputWeight != 0"
                                class="rigMsgRed"
                              >
                                Required
                              </p>
                            </label>
                            <label>
                              <div :class="{ borRed2: totalShipmentFlag.flagThree }">
                                <input
                                  style="width: 220px"
                                  class="inputAll w1"
                                  type="text"
                                  placeholder="Total Volume "
                                  v-model="inputCBM"
                                  @keyup="inputCBM = checkNumFour(inputCBM)"
                                />
                                <p class="rigW" v-if="VolumeUnit == 0">CBM</p>
                                <p class="rigW" v-if="VolumeUnit == 1">CFT</p>
                              </div>
                            </label>
                            <label class="hint tipsText">
                              <i class="fa fa-tips4 colBlue fontSet"></i>
                              <div class="floTipBox" style="left: -23px; top: 35px">
                                <i></i>
                                <p v-show="VolumeUnit == 0">
                                  Volume CBM= (length CM* width CM* height CM) /1000000
                                </p>
                                <p v-show="VolumeUnit == 1">
                                  Volume CFT= (length IN/12) * (width IN/12) * (height
                                  IN/12)
                                </p>
                              </div>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li v-show="PacketType == 2" class="cl marTop10">
                    <b class="title">Shipment units： </b>
                    <div class="text">
                      <label class="l">
                        <el-radio v-model="DocUnit" :label="0">KG</el-radio>
                        <el-radio v-model="DocUnit" :label="1">LB</el-radio>
                      </label>
                      <label class="l marL30">
                        <div :class="{ borRed2: totalShipmentFlag.flagThree }">
                          <label>
                            <input
                              style="width: 205px"
                              class="inputAll w1"
                              type="text"
                              v-model="inputWeight"
                              placeholder="Weight"
                              maxlength="100"
                              @keyup="inputWeight = checkNum(inputWeight)"
                              @blur="totalShipmentGoBlur(inputWeight, 3)"
                            />
                            <p class="rigW" v-show="DocUnit == 0">KG</p>
                            <p class="rigW" v-show="DocUnit == 1">LB</p>
                          </label>
                        </div>
                        <p v-show="totalShipmentFlag.flagThree" class="rigMsgRed">
                          {{ tipsMsg }}
                        </p>
                      </label>
                      <label class="l marL30">
                        <p>
                          <em
                            >{{ InterceptUnit(docWeightKG, 3) }} KG/{{
                              InterceptUnit(docWeightLB, 4)
                            }}
                            LB</em
                          >
                        </p>
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="chkThreeCon" v-show="PacketType == 1">
              <div class="line"></div>
              <div class="tyCargo_title">
                Which of the following items does your shipment contain?
              </div>
              <div class="chkContent">
                <typeCargo @byCargo="byCargo"></typeCargo>
                <!-- <div class="marL20">
                  <p style="font-size: 13px">
                    <el-checkbox
                      v-model="chkTerms"
                      style="margin-right: 10px"
                    ></el-checkbox>
                    <span>
                      I have read the
                      <a class="colBlue" @click="clkContraband">contraband statement</a>
                      and confirm that the shipment is not contraband
                    </span>
                  </p>
                </div> -->
              </div>
              <div class="cl"></div>
            </div>
            <div class="btnSetMar">
              <a class="sureBtn" @click="clkEnEnquiry">ENQUIRY</a>
            </div>
          </div>

          <!-- 是否已经阅读了违禁品声明 -->
          <div class="frameBg" v-show="showModal"></div>
          <div class="frameInput2" v-show="statement">
            <div class="frameHead indexHead clear">
              <p class="l"></p>
              <p @click="getClose" class="r" style="font-size: 26px">×</p>
            </div>
            <div class="content" style="text-align: center">
              <div style="margin: 40px 30px 0 30px">
                <p>
                  <i class="fa fa-tips2 colRed" style="font-size: 56px"></i>
                </p>
                <h2 class="marTop20">Please declare truthfully</h2>
                <p class="marTop10" style="font-size: 14px; line-height: 24px">
                  Please read the contraband statement and confirm that the item shipped
                  is not contraband
                </p>
              </div>
            </div>
            <div class="framePwBtn">
              <a class="sureA" @click="getClose">Confirm</a>
            </div>
          </div>
          <!-- 违禁品声明弹框  -->
          <contraband ref="contraRef"></contraband>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!--快递查价条件  end-->

    <!--快递查价列表  start-->
    <div class="mainBox" v-show="isShowList">
      <div class="listContent">
        <!-- <div class="chkListTop">
          <p>
            <b>{{ startCityEn }}</b>
            <i class="fa fa-arrowEdit"></i>
            <b>{{ desCountryEn }}</b>
            <a class="blueBtnMax marL30" @click="clkEditCond" v-if="!(this.$route.query.zt == 1)">Edit Search</a>
          </p>
          <ul>
            <li>Package type:{{ PacketTypeName(PacketType) }}</li>
            <li v-if="PacketType == 1">Commodity:{{ goodsInfos }}</li>
            <li v-if="PacketType == 1 && !(this.$route.query.zt == 1)"></li>
            <li v-if="!(this.$route.query.zt == 1)">
              Cargo ready:{{ GoodsReadyTime | dateFmt("MMM DD, YYYY") }}
            </li>
          </ul>
        </div> -->
      </div>
      <div class="listContent" v-show="isData" style="border-radius: 10px">
        <div class="chkListTwo">
          <ul>
            <li class="l chkListTitleL typeChose" style="width: 100%">
              <div>Type of service:</div>
              <button
                v-for="(item, index) in TypeList"
                :key="index"
                @click="TypeCheck(item.value)"
                :class="TypeActived == item.value ? 'TypeActived' : ''"
              >
                {{ item.lable }}
              </button>
            </li>
            <li class="l chkListTitleL" style="margin: 10px 0 0">
              <div class="type_item">
                <div>Sort by:</div>
                <button
                  v-for="(item, index) in DAPList"
                  :key="index"
                  @click="clkSort(item.name, item.value)"
                  :class="DAPactived == item.value ? 'DAPactived' : ''"
                >
                  {{ item.lable }}
                </button>
              </div>
            </li>
            <li class="l chkListTitleL" style="padding: 8px 0 0 60px">
              <!-- <span class="colRed"
                >The price changes frequently during the epidemic period, and the actual
                cost is subject to the receipt</span -->
              <!-- > -->
            </li>
            <li class="r chkListPage" v-if="isShowpage">
              <span>{{ total }} Results</span>
              <a @click="prevClick(currentPage - 1)" v-if="isPrevDisabled()">
                <i class="fa fa-ArrMin tranForm180"></i>
              </a>
              <a v-else style="cursor: default">
                <i class="fa fa-ArrMin tranForm180" style="color: #ddd"></i>
              </a>
              <span>
                <b class="colBlue">{{ currentPage }}</b>
                / {{ Math.ceil(total / pageSize) }}
              </span>
              <a @click="nextClick(currentPage + 1)" v-if="isNextDisabled()">
                <i class="fa fa-ArrMin"></i>
              </a>
              <a v-else style="cursor: default">
                <i class="fa fa-ArrMin" style="color: #ddd"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="expListData" v-show="isData">
        <div class="dataLeft">
          <div>
            <h4><span>Type of shipping</span><a @click="transChkAll()">All</a></h4>
            <el-checkbox-group
              class="chkMode"
              v-model="chkModeCodes"
              @change="changeModeCode"
            >
              <span class="transType" v-for="(item, index) in modeCodesItem" :key="index">
                <el-checkbox
                  :label="item.Code"
                  :key="item.ID"
                  v-if="
                    item.Code != 'LINE' &&
                    item.Code != 'ARAMEX' &&
                    item.Code != 'E-line' &&
                    TypeActived == 0
                  "
                  >{{ item.Name }}</el-checkbox
                >
                <el-checkbox
                  :label="item.Code"
                  :key="item.ID"
                  v-if="
                    item.Code != 'DHL' &&
                    item.Code != 'UPS' &&
                    item.Code != 'FEDEX' &&
                    TypeActived == 1
                  "
                  >{{ TypeActived == 0 ? item.Name : item.Code }}</el-checkbox
                >
                <a @click="onlyTrans(item.Code)" class="onlyTrans">Only</a>
              </span>
            </el-checkbox-group>
          </div>
          <div v-if="ThWorkDayList.length > 0 && FromType == 0">
            <h4><span>Timeliness of pick-up</span></h4>
            <el-checkbox-group class="chkMode" v-model="ThWorkDay" @change="chgThkDay">
              <span class="transType" v-for="(item, index) in ThWorkDayList" :key="index">
                <el-checkbox :label="item" :key="index"
                  >{{ item }}<span>&nbsp;Days</span></el-checkbox
                >
              </span>
            </el-checkbox-group>
          </div>
        </div>
        <div class="dataRight">
          <table
            border="0"
            cellspacing="0"
            cellpadding="0"
            class="listTable"
            width="100%"
            v-for="(item, index) in basicInfo"
            :key="index"
            v-if="index < showData"
            v-show="isTable"
          >
            <tr>
              <td width="20%" align="center" class="pad10">
                <p>
                  <img :src="iconUrl(item.ModeName)" width="30" height="30" />
                </p>
                <p>
                  <b>{{ item.ModeCode }}（{{ item.WareShortCode }}）</b>
                </p>
                <p>
                  <label class="tipBg colGray6" v-if="isBatteryText(item) == 1"
                    >Battery info. required</label
                  >
                  <label class="tipBg colGray6" v-if="isBatteryText(item) == 0"
                    >No battery info. is required</label
                  >
                  <!-- {{item.BatteryRequired}} -->
                </p>
              </td>
              <td width="64%" align="left" class="pad10">
                <p>
                  <!-- <span class="l" v-show="item.MinWorkDay != item.MaxWorkDay">Estimated Transit Time: {{item.MinWorkDay}}-{{item.MaxWorkDay}} Days</span>
									<span class="l"	v-show="item.MinWorkDay == item.MaxWorkDay">Estimated Transit Time: {{item.MinWorkDay}} Days</span> -->
                  <label class="l"
                    >Recent transit time:
                    <span v-if="item.RecentWorkDays > 0"
                      >{{ item.RecentWorkDays }} Days</span
                    ><span v-else>{{ item.WorkDaysStr }}</span>
                    <label class="hint"
                      ><a class="fa fa-tips4 colBlue font16"></a>
                      <div class="floTipBox" style="left: -28px; top: 28px">
                        <i style="left: 11%"></i>
                        <p>The actual transit days in latest 30 days</p>
                      </div>
                    </label>
                    <!-- <span v-if="item.RecentWorkDays > 0">{{item.RecentWorkDays}} Days</span><span v-else>--</span></label> -->
                  </label>
                  <label class="r marL10"
                    >Chargeable weight: {{ item.ChargeWeight }}KG</label
                  >
                </p>
                <p class="cl"></p>
                <!-- <span>Recent transit time: <span v-if="item.RecentWorkDays > 0">{{item.RecentWorkDays}} Days</span><span v-else>--</span></p> -->
                <p>Valid until: {{ item.ValidEndDate | dateFmt("MMM DD, YYYY") }}</p>
                <p v-if="PacketType == 1">Commodity: {{ item.CargoTypeInfoEn }}</p>
              </td>
              <td align="center" class="pad10">
                <p>
                  <b v-if="!item.IsDiscount" class="colRed font14"
                    >US ${{ item.Amount }}</b
                  >
                  <b v-if="item.IsDiscount" class="colRed font14"
                    >US ${{ item.DiscountAmount }}</b
                  >
                </p>
                <p>
                  <a class="blueBtnW marTop5" v-if="isShowSel" @click="clkSelectOrd(item)"
                    >SELECT</a
                  >
                  <a class="blueBtnW marTop5" v-if="!isShowSel">SELECT</a>
                </p>
                <p>
                  <a class="colBlue" @click="clkPriDown(item)"
                    ><em class="l">Price breakdown</em
                    ><i
                      class="fa fa-caret-down2 font12 marL5 r"
                      :style="
                        item.ieTrue
                          ? 'transform:rotate(180deg);transition:all 0.2s;margin-top:6px;'
                          : 'margin-top:6px;transition:all 0.2s'
                      "
                    ></i
                  ></a>
                </p>
              </td>
            </tr>
            <tr class="feeList" v-show="item.ieTrue">
              <td colspan="3">
                <div class="title">
                  <h3 class="colBlue">
                    {{ startCityEn }} > EXPRESS > {{ desCountryEn }}
                  </h3>
                </div>
                <table
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  class="listTable2"
                  width="100%"
                >
                  <tr style="font-size: 14px">
                    <th width="40%" align="left">Cost items</th>
                    <th width="18%" align="left">Unit rate</th>
                    <th width="17%" align="left">QTY</th>
                    <th align="right">Amount</th>
                  </tr>
                  <tr>
                    <td>
                      <p>Express Rate</p>
                    </td>
                    <td>
                      <p v-if="!item.IsDiscount">
                        US ${{
                          (item.TrafficAmount / Number(item.ChargeWeight)).toFixed(2)
                        }}
                      </p>
                      <p v-if="item.IsDiscount">
                        US ${{
                          (
                            item.DiscountTrafficAmount / Number(item.ChargeWeight)
                          ).toFixed(2)
                        }}
                      </p>
                    </td>
                    <td>
                      <p>{{ Number(item.ChargeWeight).toFixed(3) }}KG</p>
                      <!-- <p v-if="PacketType==1">{{Number(allWeight).toFixed(3)}}KG</p>
											<p v-if="PacketType==2">{{Number(docWeightKG).toFixed(3)}}KG</p>-->
                    </td>
                    <td align="right">
                      <!-- IsDiscount是否有分泡折扣  -->
                      <p class="colRed" v-if="!item.IsDiscount">
                        <!-- 折扣前运费（第一行） -->
                        <b>US ${{ item.TrafficAmount.toFixed(2) }}</b>
                      </p>
                      <p class="colRed" v-if="item.IsDiscount">
                        <!-- 折扣后运费 -->
                        <b>US ${{ item.DiscountTrafficAmount }}</b>
                      </p>
                    </td>
                  </tr>
                  <tr v-if="item.THAmount > 0">
                    <td>
                      <p>
                        Pickup Charge <span>({{ item.ThWorkDay }} days)</span>
                        <!-- <em v-if="item.ThWorkDay>1">days</em><em v-if="item.ThWorkDay==1">day</em>) -->
                      </p>
                    </td>
                    <td>US ${{ Number(item.THAmount).toFixed(2) }}</td>
                    <td>1 Shipment</td>
                    <td align="right">
                      <p class="colRed">
                        <b>US ${{ Number(item.THAmount).toFixed(2) }}</b>
                      </p>
                    </td>
                  </tr>
                  <template v-for="(info, index) in item.FeeInfo">
                    <tr :key="index" v-if="!info.IsAddFreight">
                      <td>
                        <p>{{ info.FeeNameEn }}</p>
                        <p class="spcText">{{ info.FeeDescEn }}</p>
                      </td>
                      <td>US ${{ Number(info.Price / info.Quanlity).toFixed(2) }}</td>
                      <td>{{ info.Quanlity }} {{ conversioUnit(info.FeeUnit) }}</td>
                      <td align="right">
                        <p class="colRed">
                          <b>US $ {{ Number(info.Price).toFixed(2) }}</b>
                        </p>
                        <p class="spcText" v-show="info.MaxValue || info.MinValue">
                          (
                          <span v-show="info.MaxValue"
                            >Max. US ${{ Number(info.MaxValue).toFixed(2) }}</span
                          >
                          <span v-show="info.MinValue"
                            >,Min. US ${{ Number(info.MinValue).toFixed(2) }}</span
                          >)
                        </p>
                      </td>
                    </tr>
                  </template>

                  <tr class="totalSet">
                    <th colspan="3" align="right">
                      <label class="hint">
                        <i class="fa fa-tips colRed marR5" style="margin-top: -2px"></i>
                        <div
                          class="floTipBox"
                          style="width: 350px; left: -43px; top: 30px"
                        >
                          <i style="right: 55px"></i>
                          <p>
                            >After the warehouse receives your shipment, the payment will
                            be automatically deducted from your Freightshop account
                            according to the cost of the actual shipment.
                          </p>
                          <p>
                            >if your account balance is insufficient, we will inform you
                            by email timely recharge,so as to avoid delivery delay.
                          </p>
                        </div>
                      </label>
                      <b>Total: </b>
                    </th>
                    <th align="right">
                      <b class="colRed" v-if="!item.IsDiscount"
                        >US ${{ Number(item.Amount).toFixed(2) }}</b
                      >
                      <b class="colRed" v-if="item.IsDiscount"
                        >US ${{ Number(item.DiscountAmount).toFixed(2) }}</b
                      >
                    </th>
                  </tr>
                  <tr v-if="item.DetailEn">
                    <td colspan="4" style="border: 0px">
                      <div class="MainRate">
                        <p v-html="item.DetailEn">{{ item.DetailEn }}</p>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <!-- 没有数据 -->
          <div class="listDataNone" v-show="isDataNone">
            <div class="textNone">
              <!-- <p>
								<img src="../../../assets/img/noDataIcon.png" style="width:52px;height:52px;">
							</p>
							<p>There is no real-time quote for Freightshop, you can contact customer service.</p> -->
              <div class="empty-box">
                <img src="/static/img/fyImg/empty.png" width="167px" height="134px" />
                <p>
                  No quotation found at moment,please contact our custom service to
                  inquiry case by case.
                </p>
              </div>
            </div>
          </div>
          <!-- 没有数据 -->
          <div class="pagination">
            <div class="listBotMore" v-if="isShowMore && isTable">
              <a class="More" @click="clkMore"
                >More <i class="fa fa-shuangxiajiantou"></i
              ></a>
            </div>
            <el-pagination
              v-if="isShowpage"
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              @prev-click="prevClick"
              @next-click="nextClick"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <div class="cl"></div>
      </div>
      <!-- 加载中，没有数据 -->

      <div class="listDataNone" v-show="isLoading">
        <div class="textNone">
          <p class="padTop10">
            <img
              src="../../../assets/img/loading.gif"
              style="width: 50px; height: 50px"
            />
          </p>
          <p style="padding-top: 5px"></p>
        </div>
      </div>
    </div>
    <!--快递查价列表  end-->
  </div>
</template>

<script>
import Vue from "vue";
import { post, fetch, Del, put } from "@/ask/axios";
import bus from "@/ask/eventBus";
import menberMenu from "../../userCenter/public/menberPageMenu.vue";
import typeCargo from "../../userCenter/public/typeCargo.vue";
import expStartCity from "../../userCenter/public/expStartCity.vue";
import expDesCountry from "../../userCenter/public/expDesCountry.vue";
import contraband from "../../userCenter/public/contraband.vue";
import { Generalcargo } from "@/ask/util";
import { getCookie, delCookie, setCookie } from "@/ask/cookiejs";
import { elAlert } from "@/utils/bulletBox";
import $ from "jquery";
export default {
  components: { menberMenu, typeCargo, expStartCity, expDesCountry, contraband },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: "",
      },
      props: {
        sortChose: {},
      },
      titNames: "Express Quotes",
      titUrls: "",
      checkIs0Flag: true,
      isReq: 0, //是否显示红色的线提示为空 --- 1：起运城市，2：货好时间 3：目的国家，
      totalShipmentFlag: { flagOne: false, flagTwo: false, flagThree: false }, //按总出货量的下的input的空框开关
      tipsMsg: "", //下单类型为包裹，重量输入框提示语
      //仓库
      FromType: 1,
      chkInputOptions: [
        {
          value: 0,
          label: "Factory/warehouse",
          description: "if you need us to pick up your goods from your supplier directly",
        },
        {
          value: 1,
          label: "Freightshop Warehouse",
          description: "if your supplier will deliver the goods to Freightshop warehouse",
        },
      ],

      GoodsReadyTime: new Date(), //货好时间
      datePickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(new Date()).setDate(new Date().getDate() - 1) ||
            time.getTime() > new Date(new Date()).setDate(new Date().getDate() + 29)
          );
        },
      },

      startCityEn: "", //起运城市英文名
      startCityCh: "", //起运城市中文名
      startCityKey: "", //起运城市Key

      desCountryEn: "", //目的国家英文名
      desCountryKey: "", //目的国家Key

      PacketType: 1, //包裹类型。1：WPX  2:DOC

      QueryType: 2, //按每件计算还是货物重量计算，1：总量计算，2：每件计算
      VolumeUnit: 0, //计算单位 0：厘米，1：英寸
      DocUnit: 0, //计算单位 0：KG，1：LB
      queryDate: "", //存储查价的数据
      //显示总量
      // sumUnit:null,//件数
      //sumKG:null, //KG
      //  sumCBM:null, //CBM
      // sumLB:null,//LB
      // sumCFT:null,//CFT
      //包裹
      //单件计算
      radCargo: [
        {
          Quanlity: null,
          Long: null,
          Wide: null,
          Height: null,
          Weight: null,
          isCol1: false,
          isCol2: false,
          isCol3: false,
          unitOptions: [
            { value: 1, label: "Carton" },
            { value: 2, label: "Pallet" },
            { value: 3, label: "Wooden Case" },
            { value: 4, label: "Other" },
          ],
          OrderUnit: 1,
        }, //isCol== 1:数量为空，2：长宽高为空，3：重量为空
      ],
      //总量信息计算
      unitOptions: [
        { value: 1, label: "Carton" },
        { value: 2, label: "Pallet" },
        { value: 3, label: "Wooden Case" },
        { value: 4, label: "Other" },
      ],
      unitValue: 1,

      //总量计算
      inputUnits: null, //输入件数
      inputWeight: null, //输入重量
      inputCBM: null, //输入总体积

      cargoInfoObj: {}, //特殊货物
      tempCargo: {
        carInfoCh: [],
        cargoID: [],
        cargoInfoEn: [],
      }, //临时存储货物（用来传值）
      isGoodsTips: false, //未选择货物种类时提示
      chkTerms: true, //是否阅读违禁品声明
      showModal: false, //遮罩层
      statement: false, //是否已经阅读违禁品声明
      yzSuccess: false, //下单后为true 验证是否成功  用在从编辑回退时的判断

      //--------查价列表--------//
      //查价头部信息
      goodsInfos: "", //包含货物
      allUnits: "",
      allWeight: "",
      allCBM: "",

      basicInfo: [], //查价列表
      //运输方式
      chkModeCodes: ["DHL", "UPS", "FEDEX", "TNT", "EMS", "DPD","SF"],
      modeCodesItem: [],
      //时效筛选
      ThWorkDayList: [],
      ThWorkDay: [],

      isIndeterminateExp: true,
      transCheckAll: false,

      //分页
      currentPage: 1, //当前页数
      pageSize: 20, //，每页显示的条数
      total: 0, //查询结果条数

      isDataNone: false, //是否有渠道数据
      isLoading: false, //加载中...
      isData: true,
      isTable: true,

      //快递列表内容
      isShowCond: false, //上面的条件列表
      isShowList: false, //是否显示列表内容
      isShowFee: false, //是否显现费用项

      //排序
      orderSort: "comprehensive",
      showData: 5, //每页显示多少行
      isShowMore: false, //是否显示查看更多

      isShowSel: true, //下单按钮是否给点击下单
      isNormalGood: null,
      wonned: false, //是否选择了木箱
      activeNames: [],
      showNum: [],
      DAPactived: 0,
      DAPList: [
        {
          lable: "Comprehensive",
          value: 0,
          name: "comprehensive",
        },
        {
          lable: "Cheapest",
          value: 1,
          name: "price",
        },
        {
          lable: "Top-selling",
          value: 2,
          name: "expsale",
        },
        {
          lable: "Quickest",
          value: 3,
          name: "workday",
        },
      ],
      TypeActived: 0,
      TypeList: [
        {
          lable: "DAP express",
          value: 0,
        },
        {
          lable: "DDP service",
          value: 1,
        },
      ],
      startInput: "",
      cityWidth: "",
    };
  },

  created() {
    this.getModeCodesApi(); //运输方式接口
    if (this.$route.query) {
      this.$nextTick(() => {
        let checkData = this.$route.query;
        this.$refs.startInput.inputText = checkData.startCityEn;
        this.$refs.endInput.inputText = checkData.desCountryEn;
        this.startCityKey = checkData.startCityKey;
        this.desCountryKey = checkData.endCityKey;
        this.isNormalGood = checkData.isNormalGood;
        this.QueryType = 1;
        this.PacketType = 1;
        this.allUnits = checkData.Quanlity;
        this.cargoInfoObj = JSON.parse(checkData.cargoInfoObj);
        // this.api.param.CargoTypeIDs = checkData.cargoInfoObj
        this.allWeight = checkData.weight;
        this.allCBM = checkData.volume;
        // this.CBM = checkData.volume;
        this.startCityEn = checkData.startCityEn;
        this.desCountryEn = checkData.desCountryEn;
        this.inputUnits = checkData.Quanlity;
        this.inputWeight = checkData.weight;
        this.inputCBM = checkData.volume;
        this.chkTerms = true;
        this.radCargo = [];
        // console.log(99999, checkData, this.startCityEn);
        // this.clkEnEnquiryAPI();
        this.clkEnEnquiry();
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        var cityWidth = document.getElementById("cityWidth");
        this.cityWidth = $(cityWidth).width();
      }, 100);
      console.log(this.cityWidth, "this.cityWidth");
    });
  },
  watch: {
    //起运城市
    startCityKey(newValue, oldValue) {
      if (newValue) {
        this.isReq = 0;
      }
    },

    //货好时间
    GoodsReadyTime(newValue, oldValue) {
      if (newValue) {
        this.isReq = 0;
      }
    },
    //目的国家
    desCountryKey(newValue, oldValue) {
      if (newValue) {
        this.isReq = 0;
      }
    },
    //监听货物种类选择没有
    cargoInfoObj(newValue, oldValue) {
      //console.log('newValuecargoInfoObj ' + JSON.stringify(newValue))
      if (!newValue) {
        this.isGoodsTips = true;
      } else {
        this.isGoodsTips = false;
      }
    },
  },
  computed: {
    //计算属性周期函数
    //把选择LB单位，换算成KG,把选择CFT单位，换算成CBM,
    //sumUnits:'',sumKG:'',sumCBM:'',//总件数、总重量、总体积
    sumUnit() {
      //件数总计
      let num = 0;
      if (this.radCargo) {
        this.radCargo.forEach((e) => {
          num += Number(e.Quanlity);
        });
        if (isNaN(num)) {
          this.inputUnits = 0;
          return 0;
        }
        if (num === 0) {
          this.inputUnits = null;
        } else {
          this.inputUnits = num;
        }
      }
      return num;
    },
    //KG单位换算
    sumKG() {
      let num = 0;
      //VolumeUnit=0 KG；VolumeUnit=1 LB
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach((e) => {
            return (num += e.Quanlity * e.Weight);
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach((e) => {
            return (num += e.Quanlity * (e.Weight * 0.4535924));
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      if (num > 0) {
        this.inputWeight = Number(num).toFixed(3);
      } else {
        this.inputWeight = null;
      }
      // console.log('this.inputWeight ' + this.inputWeight)
      //console.log('num ' + num)
      return num.toFixed(3);
    },
    //磅单位换算
    sumLB() {
      let num = 0;
      //VolumeUnit=0 KG；VolumeUnit=1 LB
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach((e) => {
            return (num += e.Quanlity * (e.Weight * 2.2046226));
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach((e) => {
            return (num += e.Quanlity * e.Weight);
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }

      return num.toFixed(3);
    },

    //VolumeUnit=0 CBM；VolumeUnit=1 CFT
    //CBM单位换算
    sumCBM() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach((e) => {
            num += ((e.Long * e.Wide * e.Height) / 1000000) * e.Quanlity;
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach((e) => {
            num +=
              ((e.Long * 2.54 * (e.Wide * 2.54) * (e.Height * 2.54)) / 1000000) *
              e.Quanlity;
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      if (num > 0) {
        this.inputCBM = Number(num).toFixed(4);
      } else {
        this.inputCBM = null;
      }
      // console.log('df ' + this.inputCBM)
      return num.toFixed(4);
    },
    sumCFT() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach((e) => {
            num +=
              ((e.Long * 0.3937008 * (e.Wide * 0.3937008) * (e.Height * 0.3937008)) /
                1000000) *
              e.Quanlity;
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach((e) => {
            num += ((e.Long * e.Wide * e.Height) / 1000000) * e.Quanlity;
          });
        }
      }

      if (isNaN(num)) {
        return 0;
      }
      return num.toFixed(4);
    },

    //选择文件时的重量换算
    docWeightKG() {
      if (this.PacketType == 2) {
        if (this.DocUnit == 0) {
          return this.inputWeight;
        } else if (this.DocUnit == 1) {
          return (this.inputWeight * 0.4535924).toFixed(3);
        }
      }
    },

    docWeightLB() {
      if (this.PacketType == 2) {
        if (this.DocUnit == 0) {
          return this.inputWeight * 2.2046226;
        } else if (this.DocUnit == 1) {
          return this.inputWeight;
        }
      }
    },

    //是否显示分页
    isShowpage() {
      let k = false;
      if (this.total <= 5 || this.isShowMore == false) {
        k = true;
      }
      return k;
    },
  },
  methods: {
    TypeCheck(value) {
      this.TypeActived = value;
      if (this.TypeActived == 0) {
        this.chkModeCodes = ["DHL", "UPS", "FEDEX", "TNT", "EMS", "DPD","SF"];
        this.clkEnEnquiryAPI();
      } else {
        this.chkModeCodes = ["LINE", "E-line", "TNT"];
        this.clkEnEnquiryAPI();
      }
    },
    handleChange(val) {
      // console.log("val", (this.$refs.startInput.inputText = 1));

      this.showNum = val;
    },
    //-------快递查价第一部分条件输入-------------//
    //包裹类型切换，赋值
    clkPacketType(val) {
      this.PacketType = val;
      this.inputWeight = null;
    },
    //每件计算还是总量计算
    clkQuType(val) {
      this.QueryType = val;
      if (this.QueryType == 1) {
        this.radCargo = [];
      } else {
        this.radCargo = [
          {
            Quanlity: null,
            Long: null,
            Wide: null,
            Height: null,
            Weight: null,
            isCol1: false,
            isCol2: false,
            isCol3: false,
            unitOptions: [
              { value: 1, label: "Carton" },
              { value: 2, label: "Pallet" },
              { value: 3, label: "Wooden Case" },
              { value: 4, label: "Other" },
            ],
            OrderUnit: 1,
          },
        ];
      }
    },

    //点击增加图标
    addPackItem() {
      return {
        Quanlity: null,
        Long: null,
        Wide: null,
        Height: null,
        Weight: null,
        isCol1: false,
        isCol2: false,
        isCol3: false,
        unitOptions: [
          { value: 1, label: "Carton" },
          { value: 2, label: "Pallet" },
          { value: 3, label: "Wooden Case" },
          { value: 4, label: "Other" },
        ],
        OrderUnit: 1,
      };
    },
    //货件信息
    addPackage() {
      //增加包裹
      this.radCargo.push(this.addPackItem());
    },
    delPackage(index) {
      //删除包裹
      if (this.radCargo.length > 1) {
        this.radCargo.splice(index, 1);
      }
    },
    //input失去焦点时验证
    radCargoBlur(item) {
      if (item.Quanlity) {
        item.isCol1 = false;
      }
      if (item.Long && item.Wide && item.Height) {
        item.isCol2 = false;
      }
      if (item.Weight) {
        item.isCol3 = false;
      }
    },
    //input失去焦点的时候，---Calculate by total shipment选项
    totalShipmentGoBlur(item, index) {
      if (item && index === 1) {
        this.totalShipmentFlag.flagOne = false;
      }
      if (item && index === 2) {
        this.totalShipmentFlag.flagTwo = false;
      }
      if (item && index === 3) {
        this.totalShipmentFlag.flagThree = false;
      }
    },
    checkNumInt(ctrValue) {
      if (ctrValue == 0) {
        ctrValue = "";
      }
      if (ctrValue) {
        ctrValue = ctrValue.replace(/\D/g, "");
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 4) {
          ctrValue = arr[0].substring(0, 4);
        }
      }

      return ctrValue;
    },
    checkNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 4);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }

        return ctrValue;
      }
    },
    checkNumFour(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 4) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 5);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }

        return ctrValue;
      }
    },
    //起运城市组件取值
    byCityValue(msg) {
      // console.log('msg1  ' + JSON.stringify(msg))
      this.startCityEn = msg.expCityEn;
      this.startCityCh = msg.expCityCh;
      this.startCityKey = msg.citykey;
    },
    //目的国家组件取值
    byCountryValue(msg) {
      // console.log('msg  ' + JSON.stringify(msg))
      this.desCountryEn = msg.expCounEn;
      this.desCountryKey = msg.citykey;
    },
    //特殊货物取值
    byCargo(msg, isNormalGood) {
      console.log("isNormalGood", msg, isNormalGood);
      this.isNormalGood = isNormalGood; // 是不是选每次 false 为选了，其余为没选
      this.cargoInfoObj = msg;
    },
    //违禁品声明
    getClose() {
      this.showModal = false;
      this.statement = false;
    },
    //点击违禁品声明弹框
    clkContraband() {
      this.$refs.contraRef.clkOpenBox();
    },

    //获取费用计算单位
    conversioUnit(Code) {
      if (Code == 1) return `B\\L`;
      if (Code == 2) return "KG";
      if (Code == 3) return "Unit";
      if (Code == 4) return "Pcs";
      if (Code == 5) return "台";
      if (Code == 6) return "CBM";
      if (Code == 7) return "Time";
    },

    //列表内容运输方式图标路径
    iconUrl(valName) {
      let url = "";
      if (valName.indexOf("DHL") != -1) {
        url = "../../../static/img/dhl.png";
      } else if (valName.indexOf("UPS") != -1) {
        url = "../../../static/img/ups.png";
      } else if (valName.indexOf("FEDEX") != -1) {
        url = "../../../static/img/fedex.png";
      } else if (valName.indexOf("TNT") != -1) {
        url = "../../../static/img/tnt.png";
      } else if (valName.indexOf("LINE") != -1) {
        url = "../../../static/img/speclalLine.png";
      } else {
        url = "../../../static/img/speclalLine.png";
      }
      return url;
    },
    PacketTypeName(code) {
      if (code == 1) return "Package";
      if (code == 2) return "Docs";
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.clkEnEnquiry();
    },
    prevClick(val) {
      //点击上一页
      this.currentPage = val;
      this.clkEnEnquiry();
    },
    nextClick(val) {
      //点击下一页
      this.currentPage = val;
      this.clkEnEnquiry();
    },
    //上一页最后超出了总页数禁用
    isPrevDisabled() {
      //math.ceil保留小数取整
      if (this.currentPage > 1) {
        return true;
      } else {
        return false;
      }

      // let totalPage = Math.ceil(this.total / this.pageSize)
      // if (this.currentPage < totalPage) {
      //   // this.isPrevDisabled()
      //   return false
      // } else {
      //   return true
      // }
    },

    //下一页最后超出了总页数禁用
    isNextDisabled() {
      let totalPage = Math.ceil(this.total / this.pageSize);
      if (this.currentPage >= totalPage) {
        // this.isPrevDisabled()
        return false;
      } else {
        return true;
      }
    },
    //判断是否有数字为0
    checkIs0() {
      if (this.PacketType == 1) {
        this.checkIs0Flag = false;
        if (this.QueryType == 1) {
          if (this.inputUnits < 0 || !Number(this.inputUnits)) {
            this.totalShipmentFlag.flagOne = true;
          } else {
            this.totalShipmentFlag.flagOne = false;
            this.totalShipmentFlag.flagTwo = false;
            this.checkIs0Flag = true;
          }
        } else {
          this.radCargo.forEach((e) => {
            if (e.Quanlity <= 0 || !Number(e.Quanlity)) {
              e.isCol1 = true;
            } else if (
              e.Long <= 0 ||
              e.Wide <= 0 ||
              e.Height <= 0 ||
              !Number(e.Wide) ||
              !Number(e.Long) ||
              !Number(e.Height)
            ) {
              e.isCol2 = true;
            } else if (e.Weight <= 0 || !Number(e.Weight)) {
              e.isCol3 = true;
            } else {
              e.isCol1 = false;
              e.isCol2 = false;
              e.isCol3 = false;
              this.checkIs0Flag = true;
            }
          });
        }
      }
    },

    //查价按钮
    clkEnEnquiry() {
      // console.log(this.showNum, "sdasds");
      this.checkIs0(); //检查是否为0
      //起运城市，货好时间，目的国家验证是否为空
      if (!this.startCityKey) {
        this.isReq = 1;
        return false;
      }
      if (!this.GoodsReadyTime) {
        this.isReq = 2;
        return false;
      }
      if (!this.desCountryKey) {
        this.isReq = 3;
        return false;
      }
      //货物种类为包裹的时候验证。
      //单件计算验证是否为空
      if (this.PacketType == 1) {
        if (this.QueryType == 2) {
          let isTrue = true;
          this.radCargo.forEach((e) => {
            if (!e.Quanlity || !e.Long || !e.Wide || !e.Height) {
              if (!e.Quanlity) {
                e.isCol1 = true;
              } else if (!e.Long || !e.Wide || !e.Height) {
                e.isCol2 = true;
              } else if (!e.Weight) {
                e.isCol3 = true;
              } else {
                e.isCol1 = false;
                e.isCol2 = false;
                e.isCol3 = false;
                isTrue = true;
              }
              isTrue = false;
            }
          });
          if (isTrue == false) {
            return false;
          }
        }
        if (this.QueryType == 1) {
          let isTrue = true;
          if (!this.inputUnits || this.inputWeight < 0) {
            if (!this.inputUnits) {
              this.totalShipmentFlag.flagOne = true;
            } else if (!this.inputWeight) {
              this.totalShipmentFlag.flagTwo = true;
            } else {
              this.totalShipmentFlag.flagOne = false;
              this.totalShipmentFlag.flagTwo = false;
              isTrue = true;
            }
            isTrue = false;
          }
          if (isTrue == false) {
            return false;
          }
        }
        //货物种类不能为空
        if (!this.cargoInfoObj.cargoID || this.cargoInfoObj.cargoID.length < 1) {
          this.isGoodsTips = true;
          return false;
        }
        //验证是否勾选了，已阅禁品申明
        if (this.chkTerms == false) {
          this.showModal = true;
          this.statement = true;
          return false;
        }
      }
      if (this.PacketType == 1) {
        ////包含货物信息赋值
        //console.log('this.cargoInfoObj.cargoInfoEn ' + JSON.stringify(this.cargoInfoObj.cargoInfoEn))
        let jsonGoods = this.cargoInfoObj.cargoInfoEn.join(",");
        this.goodsInfos = jsonGoods;

        //货物总量赋值
        if (this.QueryType == 2) {
          this.allUnits = this.sumUnit;
          this.allWeight = this.sumKG;
          this.allCBM = this.sumCBM;
        } else if (this.QueryType == 1) {
          if (this.VolumeUnit == 0) {
            this.allUnits = this.inputUnits;
            this.allWeight = this.inputWeight;
            this.allCBM = this.inputCBM;
          } else if (this.VolumeUnit == 1) {
            this.allUnits = this.inputUnits;
            this.allWeight = (this.inputWeight * 0.4535924).toFixed(3);
            this.allCBM = (this.inputCBM * 0.0283168).toFixed(4);
          }
        }
      }
      if (this.PacketType == 2) {
        if (!this.inputWeight) {
          this.tipsMsg = "Required";
          this.totalShipmentFlag.flagThree = true;
          return false;
        } else if (this.inputWeight == 0) {
          this.tipsMsg = "must be greater than 0";
          this.totalShipmentFlag.flagThree = true;
          return false;
        } else {
          this.totalShipmentFlag.flagThree = false;
        }
      }
      //便利一下isCol又没有变红
      this.radCargo.forEach((e) => {
        if (e.isCol1 || e.isCol2 || e.isCol3) {
          return (this.checkIs0Flag = false);
        }
      });
      if (this.checkIs0Flag) {
        this.isShowCond = false;
        this.showNum = [];
        (this.activeNames = []), (this.isShowList = true);
        this.clkEnEnquiryAPI();
      }

      // 调用查价接口
    },
    //查价接口数据
    clkEnEnquiryAPI() {
      let that = this;
      that.basicInfo = [];
      this.api.param = {
        FromType: this.FromType,
        GoodsReadyTime: new Date(this.GoodsReadyTime).Format("yyyy-MM-dd"),
        StartCityKey: this.startCityKey,
        CountryKey: this.desCountryKey,
        QueryType: this.QueryType,
        PacketType: this.PacketType, //包裹类型 （1：WPX 2:DOC） ,
        ModeCodes: this.chkModeCodes, //运输方式
        lstThWorkDays: this.ThWorkDay,
        ChannelKey: "",
        OrderBy: this.orderSort,
        skip: (that.currentPage - 1) * that.pageSize,
        take: that.pageSize,
        is_login: false,
        entrance: "EXPRESS",
        platform_type: "web",
      };
      this.Iswooned();

      if (this.PacketType == 1) {
        //总件数，总体积，总重量
        this.api.param.Quanlity = this.allUnits;
        this.api.param.Weight = this.allWeight;
        this.api.param.CBM = this.allCBM;
        //货物种类，当货物种类为包裹时才传值，文件时不传
        this.tempCargo = JSON.parse(JSON.stringify(this.cargoInfoObj));
        if (this.wonned) {
          this.tempCargo.carInfoCh.push("木箱");
          this.tempCargo.cargoID.push(107);
          this.tempCargo.cargoInfoEn.push("Wooden Case");
        }
        this.api.param.CargoTypeIDs = this.tempCargo.cargoID; //货物种类
        // this.api.param.CargoTypeIDs = [139] //货物种类
        if (this.$route.query.zt == 1) {
          this.tempCargo.cargoID = [this.$route.query.cargoId];
          this.tempCargo.carInfoCh = [this.$route.query.cargoNameCH];
          this.tempCargo.cargoInfoEn = [this.$route.query.cargoNameEn];
          this.api.param.CargoTypeIDs = [this.$route.query.cargoId]; //货物种类
        }

        //材积信息集合
        if (this.VolumeUnit == 0) {
          this.api.param.GoodInfos = this.radCargo; //材积信息集合
        } else if (this.VolumeUnit == 1) {
          //输入In 的时候转换为cm 传回接口
          let radCargobackup = [];
          this.radCargo.forEach((e) => {
            let radJson = {
              Quanlity: e.Quanlity,
              Long: e.Long * 2.54,
              Wide: e.Wide * 2.54,
              Height: e.Height * 2.54,
              Weight: e.Weight * 0.4535924,
            };
            radCargobackup.push(radJson);
          });
          this.api.param.GoodInfos = radCargobackup; //材积信息集合
        }
      } else if (this.PacketType == 2) {
        this.api.param.Weight = this.docWeightKG;
      }

      that.isLoading = true; //加载中...
      that.isDataNone = false; //没有数据查无订单
      that.isData = false; //有数据列表

      let isGoods = true;
      if (this.tempCargo.cargoID == sysCfg.exp.Cargo.generalCargoID) {
        isGoods = false;
      } else if (this.tempCargo.cargoID) {
        isGoods = false;
      }

      let PacketType = "";
      if (this.PacketTypeName(this.PacketType)) {
        PacketType = this.PacketTypeName(this.PacketType);
      }

      let cargoArr = [];
      if (this.PacketType == 1 && this.goodsInfos) {
        cargoArr = this.goodsInfos.split(",");
      }

      //this.checkPrice('EXPRESS', this.startCityEn, '', this.desCountryEn, '', PacketType, Number(this.api.param.Weight), Number(this.api.param.CBM), Number(this.api.param.Quanlity), isGoods, cargoArr, false, '')

      this.api.url = this.$api04 + "/Express/api/ExpCalculation/QueryPriceEN"//"/api/InfoCustomer/ExpCalculation/QueryPriceEN";
      post(this.api.url, this.api.param).then((res) => {
        let ByPrior = false;
        if (res.Results.length > 0) {
          ByPrior = res.Results[0].ByPrior;
        }
        that.searchResult(
          res.Total,
          "EXPRESS",
          this.startCityEn,
          "",
          this.desCountryEn,
          "",
          ByPrior
        );

        if (res.IsOK == true) {
          this.queryDate = JSON.parse(JSON.stringify(this.api.param));
          Generalcargo(that.isNormalGood, 0);
          that.isLoading = false;
          that.isData = true;
          if (res.Results) {
            if (res.Results.length < 0 || res.Results.length == 0) {
              that.isDataNone = true;
              that.isDataNone != that.isLoading;
            } else {
              that.isDataNone = false;
            }
          }
        } else {
          that.isLoading = false;
          that.isDataNone = true;
        }

        // that.basicInfo = res.Results;
        let tableData = res.Results;
        if (tableData.length > 0) {
          // 添加动画效果
          tableData.forEach((item, index) => {
            // 运费（必收附加费加入运费）叠加
            let trafficAmount = JSON.parse(
              JSON.stringify(
                item.IsDiscount ? item.DiscountTrafficAmount : item.TrafficAmount
              )
            );
            let feeInfo = item.FeeInfo;
            feeInfo.forEach((feeItem) => {
              if (feeItem.IsAddFreight) {
                trafficAmount += Number(feeItem.Price);
              }
            });
            if (item.IsDiscount) {
              item.DiscountTrafficAmount = Number(trafficAmount);
            } else {
              item.TrafficAmount = Number(trafficAmount);
            }
          });
          that.basicInfo.push(...tableData);
        }
        //附件费增加数量
        if (that.basicInfo) {
          that.basicInfo.forEach((e) => {
            Vue.set(e, "ieTrue", false); //是否显示费用项列表
          });
        }
        console.log("tableData", that.basicInfo, tableData);

        that.total = res.Total;

        if (that.currentPage == 1) {
          //是否显示查看更多
          if (res.Total > 5) {
            that.isShowMore = true;
            that.showData = 5;
          } else {
            that.isShowMore = false;
          }
        }

        //筛选时效转成数组，去重
        if (res.IsOK && res.Results.length > 0) {
          let array = [];
          res.Results.forEach((e) => {
            if (e.ThWorkDay > 0) {
              array.push(e.ThWorkDay);
            }
          });
          //数组去重
          let temp = []; //一个新的临时数组
          for (var i = 0; i < array.length; i++) {
            if (temp.indexOf(array[i]) == -1) {
              temp.push(array[i]);
            }
          }
          that.ThWorkDayList = temp;
          that.ThWorkDay = that.ThWorkDayList;
        } else {
          that.ThWorkDayList = [];
        }
      });
      let cityWidth = document.getElementById("cityWidth");
      this.cityWidth = $(cityWidth).width();
    },

    //是否选了木箱单位
    Iswooned() {
      this.wonned = false;
      if (this.QueryType == 2 && this.PacketType == 1) {
        for (let i = 0; i < this.radCargo.length; i++) {
          const ele = this.radCargo[i];
          //console.log(ele)
          if (ele.OrderUnit == 3) {
            this.wonned = true;
          }
        }
      }
      if (this.QueryType == 1 && this.PacketType == 1) {
        if (this.unitValue == 3) {
          this.wonned = true;
        }
      }
    },

    //--------------------第二部分的方法---------------------//
    //点击编辑订单按钮
    clkEditCond() {
      // this.isShowList = false;
      this.isShowCond = !this.isShowCond;
      this.ThWorkDay = [];
      bus.$emit("getGeneral");
      // this.checkIs0Flag = false //将
    },
    //----------------------运输方式-----------------------//
    getModeCodesApi() {
      let that = this;
      // this.api.url = this.$api01 + "/api/InfoCustomer/ModeCode/QueryExpModeCode";
      this.api.url = this.$api04 + "/Express/api/ModeCode/QueryExpModeCode";
      fetch(this.api.url).then(function (res) {
        that.modeCodesItem = res.Results;
        that.modeCodesItem.forEach((e) => {
          Vue.set(e, "isTrue", false);
        });
        //console.log('ss ' + JSON.stringify(that.modeCodesItem))
      });
    },
    //点击全部
    transChkAll() {
      if (this.TypeActived == 0) {
        this.chkModeCodes = ["DHL", "UPS", "FEDEX", "TNT", "EMS", "DPD","SF"];
      } else {
        this.chkModeCodes = ["LINE", "E-line", "TNT"];
      }
      this.clkEnEnquiryAPI();
    },
    //运输方式值改变
    changeModeCode(value) {
      //console.log('chkModeCodes ' + JSON.stringify(value))
      this.chkModeCodes = value;
      this.clkEnEnquiryAPI();
    },
    //仅此点击事件
    onlyTrans(code) {
      this.chkModeCodes = [code];
      this.clkEnEnquiryAPI();
    },
    //查询最便宜的渠道
    // Cheapest() {
    //   this.isSort = 1;
    //   this.Sort = 'amount'
    //   this.currentPage = 1
    //   this.clkEnEnquiryAPI();
    // },
    // //查询最快的渠道
    // Fastest() {
    //   this.isSort = 2;
    //   this.Sort = 'workdays'
    //   this.currentPage = 1
    //   this.clkEnEnquiryAPI();
    // },

    ////排序  综合排序 ：comprehensive  销量排序：expsale 价格排序：price  时效排序：workday
    clkSort(sort, value) {
      this.DAPactived = value;
      this.orderSort = sort;
      this.showData = 20;
      this.currentPage = 1;
      this.clkEnEnquiryAPI();
    },
    //默认显示5条，分页不显示，点击查看更多，展示一页20条
    clkMore() {
      this.showData = 20;
      this.isShowMore = false; //是否显示查看更多
    },

    //时效筛选
    chgThkDay(val) {
      //this.ThWorkDay = val
      if (this.ThWorkDay.length > 0) {
        this.isDataNone = false;
        this.clkEnEnquiryAPI();
      } else {
        this.isDataNone = true;
        this.basicInfo = [];
        this.total = 0;
      }
    },

    //---------------------快递列表----------------------//
    //点击下拉内容
    clkPriDown(item) {
      item.ieTrue = !item.ieTrue;
      console.log("item.ieTrue", item.ieTrue);
    },
    //有无电池资料
    //判断是否需要提供电池资料
    //-1：没选择电池；0：不需提供电池资料；1：需要提供电池资料
    isBatteryText(item) {
      // console.log('this.cargoInfoObj.cargoID  ' + JSON.stringify(this.cargoInfoObj.cargoID))
      // console.log('item  ' + JSON.stringify(item))
      let pure = 103; //纯电池ID
      let builtIn = 108; //内置电池ID
      let supporting = 109; //配套电池ID
      //先判断有没有选择电池 -1
      if (
        $.inArray(pure, this.cargoInfoObj.cargoID) == -1 &&
        $.inArray(builtIn, this.cargoInfoObj.cargoID) == -1 &&
        $.inArray(supporting, this.cargoInfoObj.cargoID) == -1
      ) {
        return -1;
      }

      //判断是否需求提供电池资料
      if (!item.BatteryRequired) {
        return 0;
      }

      let retChk = false; //判断结果
      //电池货要求
      //[{"BatteryType":1,"RequiredInfo":[1],"OtherInfo":null},{"BatteryType":2,"RequiredInfo":[2],"OtherInfo":null},{"BatteryType":3,"RequiredInfo":[3],"OtherInfo":null},{"BatteryType":4,"RequiredInfo":[4],"OtherInfo":"娃哈哈"}]
      let batReq = JSON.parse(item.BatteryRequired);
      batReq.forEach((e) => {
        //纯电池
        if (this.isNeedBatDoc(pure, 1, e) == true) {
          retChk = true;
          return false; //结束循环
        }
        //内置电池
        if (this.isNeedBatDoc(builtIn, 2, e) == true) {
          retChk = true;
          return false; //结束循环
        }
        //配套电池
        if (this.isNeedBatDoc(supporting, 3, e) == true) {
          retChk = true;
          return false; //结束循环
        }
        if (this.isNeedBatDoc(supporting, 4, e) == true) {
          retChk = true;
          return false; //结束循环
        }
      });
      // console.log('retChk  ' + retChk)
      return retChk ? 1 : 0;
    },

    //判断是否需要提供电池货资料
    //batID：电池货种类ID
    //batteryType：电池货要求类型
    //batReq：电池货要求
    isNeedBatDoc(batID, batteryType, batReq) {
      if (
        batReq.BatteryType == batteryType &&
        $.inArray(batID, this.cargoInfoObj.cargoID) >= 0
      ) {
        if (batReq.RequiredInfo.length > 0 && $.inArray(0, batReq.RequiredInfo) < 0) {
          return true;
        }
      }
      return false;
    },
    //点击下单按钮
    clkSelectOrd(item) {
      let token = getCookie("X-BY-EnTOKEN");
      if (token && token != null) {
        let that = this;
        // this.api.param=that.EditOrderReqEn
        // this.api.param.OrderProductInfos=that.OrderProductInfos
        this.api.param = {
          ChannelKey: item.ChannelKey, //渠道key
          //渠道返回的城市
          StartCityKey: item.StartCityKey, //起运城市key
          StartCityName: item.StartCityName, //起运城市中文名称
          StartCityNameEn: item.StartCityNameEn, //起运城市英文名称

          DestCountrKey: item.CountryKey, //目的国家key
          DestCountryName: item.CountryName, //目的国家中文名称
          DestCountryNameEn: item.CountryNameEn, //目的国家英文名称
          PackageType: that.PacketType, //包裹类型
          ModeCode: item.ModeCode, //运输方式
          GoodValue: 0, //申报价值
          QueryType: that.QueryType, //按总量还是按单件计算

          Currency: 2, //币种
          IsCopy: false, //是否复制订单
          THChannelKey: item.THChannelKey, //取件渠道key
          THChannelName: item.THChannelName, //取件渠道名称
          FromType: that.FromType, //起始类型。0：工厂，1：百运仓库 ,
          GoodsReadyTime: that.GoodsReadyTime, //货好时间

          QueryStartCityKey: item.QueryStartCityKey,
          QueryStartCityName: item.QueryStartCityName,
          QueryStartCityNameEn: item.QueryStartCityNameEn,
          CountMode: item.CountMode, //计费方式
          PlatformType: 1, //平台类型。0：中文官网，1：英文官网，2：App Android，3：App iOS，4：微信小程序，5：QQ小程序，6：百度小程序，7：字节小程序，8：H5页面，9：平台中心
          OrderWay: 0, //下单方式。0：手动下单、1复制订单、2导入订单、3接口下单
          entrance: "EXPRESS",
          platform_type: "web",
        };
        //console.log(this.api.param,item.QueryStartCityKey,that.startCityKey)
        //运输方式
        // let codeArr=that.chkModeCodes.join(',')
        // this.api.param.ModeCode=codeArr
        //货物种类Id 和 说明
        //console.log(' that.chkModeCodes' +  JSON.stringify(this.cargoInfoObj))

        //下单类型是包裹的时候
        if (that.PacketType == 1) {
          this.api.param.OrderUnit = this.unitValue;
          this.api.param.OrderCount = that.allUnits; //下单件数
          this.api.param.OrderWeight = that.allWeight; //下单实重
          this.api.param.OrderVolume = that.allCBM || 0; //下单体积
          //下单材积信息集合 OrderVolumeInfos
          if (that.QueryType == 2) {
            this.api.param.OrderVolumeInfos = that.radCargo;
          } else {
            this.api.param.OrderVolumeInfos = [];
          }
          this.api.param.VolumeUnit = that.VolumeUnit; //材积单位 新增字段。0：厘米，1：英寸

          let cargoIDArr = that.tempCargo.cargoID.join(",");
          this.api.param.CargoIDs = cargoIDArr;
          let cargoInfosArr = that.tempCargo.cargoInfoEn.join(",");
          this.api.param.CargoDescsEn = cargoInfosArr;
          let cargoInfosCh = that.tempCargo.carInfoCh.join(",");
          this.api.param.CargoDescs = cargoInfosCh;
        } else if (that.PacketType == 2) {
          this.api.param.OrderUnit = "";
          this.api.param.OrderWeight = that.docWeightKG; //下单实重
          this.api.param.VolumeUnit = that.DocUnit; //新增字段。0：厘米，1：英寸
          this.api.param.CargoIDs = "";
          this.api.param.CargoDescs = "";
        }
        ////下单附加费信息
        //this.api.param.OrderExtraFeeInfos=item.FeeInfo,//下单附加费信息
        let FeeInfoArr = [];
        item.FeeInfo.forEach((e) => {
          let jsonArr = {
            FeeID: e.FeeID,
            FeeName: e.FeeName,
            Price: e.Price,
            Quanlity: e.Quanlity,
            Amount: e.Quanlity * e.Price,
            RelatedService: e.RelatedService,
            FeeSelectType: e.FeeSelectType,
          };
          FeeInfoArr.push(jsonArr);
        });
        (this.api.param.OrderExtraFeeInfos = FeeInfoArr), //下单附加费信息
          (that.isShowSel = false);
        this.api.url = this.$api04 + "/Express/api/ExpNewOrder/AddNotConfirmOrderEn";
        //this.api.url = this.$api03 + "/api/TradeCustomer/ExpNewOrder/AddNotConfirmOrderEn";
        var newWindow = window.open();
        post(this.api.url, this.api.param).then((res) => {
          that.isShowSel = true;
          if (res.IsOK == true) {
            let amount = 0;
            let TrafficAmount = 0; //运费
            if (item.IsDiscount) {
              amount = item.DiscountAmount;
              TrafficAmount = item.DiscountTrafficAmount;
            } else {
              amount = item.Amount;
              TrafficAmount = item.TrafficAmount;
            }

            let KG = 0;
            let CBM = 0;
            let Unit = 0;
            if (that.QueryType == 2) {
              KG = that.sumKG;
              CBM = that.sumCBM;
              Unit = that.sumUnit;
            } else if (that.QueryType == 1) {
              KG = that.inputWeight;
              CBM = that.inputCBM;
              Unit = that.inputUnits;
            }
            // try {
            //   that.submitOrder(res.Results, amount, '', 'EXPRESS', that.startCityEn, '', that.desCountryEn, '', that.goodsInfos,
            //     KG, CBM, Unit, item.ChargeWeight, '', item.ChannelName, TrafficAmount, '', '', false)
            // } catch (err) {
            //   console.warn(err)
            // }

            if (that.$route.query.cargoCode) {
              newWindow.location.href =
                "/exp/expEdit?ord=" +
                res.Results +
                "&cargoCode=" +
                that.$route.query.cargoCode +
                "&Qty=" +
                that.$route.query.Qty;
            } else {
              newWindow.location.href = "/exp/expEdit?ord=" + res.Results;
            }
          } else if (res.IsOK == false) {
            newWindow.close();
            if (res.Status.Errors.length > 0) {
              let isTrue = true;
              res.Status.Errors.forEach((e) => {
                if (
                  e.ErrorCode == "S0001" ||
                  e.ErrorCode == "S0002" ||
                  e.ErrorCode == "S0003" ||
                  e.ErrorCode == "S0004"
                ) {
                  isTrue = false;
                }
              });
              if (isTrue == false) {
                that
                  .$confirm("This channel has expired!", "", {
                    customClass: "custom-message-box", //自定义添加Class
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                    closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                    showCancelButton: false, //去掉取消按钮
                    showClose: false, //去掉右上角的取消（X）
                    // type: 'warning',
                    center: true,
                  })
                  .then(() => {})
                  .catch(() => {});
                return false;
              }
            } else {
              that
                .$confirm("This channel has expired!", "", {
                  customClass: "custom-message-box", //自定义添加Class
                  confirmButtonText: "Confirm",
                  cancelButtonText: "Cancel",
                  cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
                  closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
                  showCancelButton: false, //去掉取消按钮
                  showClose: false, //去掉右上角的取消（X）
                  // type: 'warning',
                  center: true,
                })
                .then(() => {})
                .catch(() => {});
              return false;
            }
          }
        });
      } else {
        elAlert(this, "You have not logged in, please log in");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  width: 1160px;
  border: 1px dotted #dddddd;
  margin: 0 auto;
}
.tyCargo_title {
  margin-top: 19px;
  padding-left: 20px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
/deep/.el-collapse {
  border: none;
}
/deep/.collapseContent {
  .el-collapse-item__header {
    height: 0 !important;
  }
  .el-collapse-item__arrow {
    display: none !important;
  }
  .el-collapse-item__wrap {
    background: none;
    border: none;
    // position: relative;
    // top: -19px;
  }
  .el-collapse-item__content {
    padding-bottom: 0 !important;
    background: none;
    border: none;
  }
  .btnSetMar {
    width: 160px;
    padding: 0 !important;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
}

.mainUser {
  position: relative;
}
.serchbtn {
  width: 90px;
  height: 28px;
  background: #004fb1;
  border-radius: 15px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 250px;
  top: 15px;
}
.chkListTop {
  height: 85px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  box-sizing: border-box;
  transition: all 0.2s;
}
// .listContent {
//   border-radius: 0 0 10px 10px !important;
// }
.checkInput {
  li {
    padding: 0 !important;
  }
}
/deep/.radioWeight {
  .el-radio:nth-of-type(1) {
    margin-right: 187px;
  }
}
.to {
  width: 56px !important;
  margin-right: 0 !important;
}
.chkTwoUl {
  padding: 0 !important;
}
.title {
  font-size: 12px !important;
  font-family: PingFangSC-Medium, PingFang SC !important;
  // font-weight: 500 !important;
  color: #333333 !important;
}
.from {
  width: 118px !important;
  font-size: 12px !important;
  font-family: PingFangSC-Medium, PingFang SC !important;
  font-weight: 500 !important;
  color: #333333 !important;
}
.chkListTitleL {
  margin: 0 !important;
}
.typeChose {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  div {
    width: 91px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  button {
    outline: none;
    border: none;
    width: 110px;
    height: 24px;
    background: #efefef;
    border-radius: 15px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    transition: background, color 0.2s;
    cursor: pointer;
    color: #777777;
    margin-left: 10px;
  }
  button:nth-of-type(2) {
    width: 100px;
  }
}
.b {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 20px;
}
.grayBtnW {
  width: 100px !important;
  height: 24px !important;
  background: #efefef !important;
  border-radius: 15px !important;
  font-size: 12px !important;
  font-family: MicrosoftYaHei;
  color: #777777 !important;
}
.lineBlueBtnW {
  width: 100px !important;
  height: 24px !important;
  background: #004fb1 !important;
  border-radius: 15px !important;
  font-size: 12px !important;
  font-family: MicrosoftYaHei;
  color: #ffffff !important;
}
.type_item {
  display: flex;
  margin-top: 10px;
  align-items: center;

  div:nth-of-type(1) {
    width: 68px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-left: 20px;
    text-align: end;
  }
  button {
    cursor: pointer;
    outline: none;
    border: none;
    width: 100px;
    height: 24px;
    background: #efefef;
    border-radius: 15px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    transition: background, color 0.2s;

    color: #777777;
    margin: 0 0 0 10px;
  }
  button:nth-of-type(1) {
    width: 110px;
  }
  div:nth-of-type(2) {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #d83f3f;
    line-height: 18px;
    margin-left: 15px;
  }
}
.DAPactived {
  background: #004fb1 !important;
  color: #ffffff !important;
  transition: background, color 0.2s;
}
.TypeActived {
  background: #004fb1 !important;
  color: #ffffff !important;
  transition: background, color 0.2s;
}
.chkThreeCon {
  /deep/.cargoItemWidth {
    padding: 0 0 20px !important;
  }
  /deep/ .el-checkbox {
  }
  /deep/ .el-checkbox:nth-of-type(1) {
    width: 213px !important;
    margin-left: 0;
  }
  /deep/ .el-checkbox:nth-of-type(2) {
    width: 293px !important;
  }
  /deep/ .el-checkbox:nth-of-type(3) {
    width: 293px !important;
  }
  /deep/ .el-checkbox:nth-of-type(4) {
    width: 205px !important;
  }
  /deep/ .el-checkbox:nth-of-type(5) {
    width: 152px !important;
  }
  /deep/ .el-checkbox:nth-of-type(6) {
    width: 213px !important;
    margin-left: 0;
  }
  /deep/ .el-checkbox:nth-of-type(7) {
    width: 293px !important;
  }
  /deep/ .el-checkbox:nth-of-type(8) {
    width: 293px !important;
  }
  /deep/ .el-checkbox:nth-of-type(9) {
    width: 205px !important;
  }
  /deep/ .el-checkbox:nth-of-type(10) {
    width: 152px !important;
  }
  /deep/ .el-checkbox:nth-of-type(11) {
    width: 213px !important;
    margin-left: 0;
  }
  /deep/ .el-checkbox:nth-of-type(12) {
    width: 293px !important;
  }
  /deep/ .el-checkbox:nth-of-type(13) {
    width: 293px !important;
  }
  /deep/ .el-checkbox:nth-of-type(14) {
    width: 205px !important;
  }
  /deep/ .el-checkbox:nth-of-type(15) {
    width: 152px !important;
  }
}
.topHeader {
  padding: 20px !important;
}
</style>
<style>
/*局部修改elementUI样式*/
/*!*取消按钮*!*/
/*.el-message-box__wrapper .btn-custom-cancel {float:right;margin:0 120px 0 0 !important;;}*/
/*!*确定或者删除按钮*!*/
/*.el-message-box__wrapper .el-message-box__btns button:nth-child(2){margin:0 0 0 120px !important;}*/
.unit_select .el-input__inner {
  border: none !important;
  background: #f7f7f7 !important;
  padding-left: 6px !important;
  font-size: 12px !important;
}
.unit_select .el-input__suffix {
  right: 0 !important;
}
@import "../../../assets/css/tipsMessage.css";
</style>
<style scoped>
@import "../../../assets/css/userCenterCss.css";
@import "../../../assets/css/frame.css";
.total {
  float: right !important;
  text-align: right;
  line-height: 20px;
  width: auto !important;
}
/* .chkListTop {
  background: #fff;
  height: 85px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
} */
.shipmentSpan {
  margin-right: 48px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/reception/express/frontExpress.vue